import { doc, onSnapshot } from 'firebase/firestore';
import { getFirestoreDb } from './firebase';
import { buildOrderTracking } from './orderTracking';

const toIsoTimestamp = (value) => {
  if (!value) return null;
  if (typeof value === 'string') return value;
  if (typeof value.toDate === 'function') {
    return value.toDate().toISOString();
  }
  if (value instanceof Date) {
    return value.toISOString();
  }
  return null;
};

const resolveReceiptImage = (row) => row.receipt_url || row.receipt_image || row.receipt_data_url || null;

export function mapOrderFromFirestore(id, row = {}) {
  const order = {
    id,
    customer_name: row.customer_name || row.name || null,
    phone: row.phone || null,
    address: row.address || null,
    customer_note: row.customer_note || null,
    payment_method: row.payment_method || null,
    payment_account_id: row.payment_account_id || null,
    payment_account_label: row.payment_account_label || null,
    payment_status: row.payment_status || null,
    receipt_image: resolveReceiptImage(row),
    receipt_url: row.receipt_url || null,
    receipt_name: row.receipt_name || null,
    total: row.total ?? row.total_amount ?? 0,
    status: row.status || 'pending',
    items: Array.isArray(row.items) ? row.items : [],
    requested_date: toIsoTimestamp(row.requested_date) || toIsoTimestamp(row.created_at) || null,
    message_sent: !!row.message_sent,
    completed_at: toIsoTimestamp(row.completed_at) || null,
    created_at: toIsoTimestamp(row.created_at) || null,
    admin_message: row.admin_message || null,
  };

  order.tracking = buildOrderTracking(order);
  return order;
}

export async function subscribeToOrder(orderId, onData, onError) {
  const db = await getFirestoreDb();
  const orderRef = doc(db, 'orders', orderId);

  return onSnapshot(
    orderRef,
    (snapshot) => {
      if (!snapshot.exists()) {
        onError(new Error('Order not found'));
        return;
      }

      onData(mapOrderFromFirestore(snapshot.id, snapshot.data()));
    },
    (error) => {
      onError(error);
    }
  );
}
